 document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.testimonial-slider');

  if (!slider) return;

  const totalSlides = slider.querySelectorAll('.splide__slide').length;

  var splide = new Splide(slider, {
    type: 'slide',
    perPage: 4,
    perMove: 1,
    gap: '30px',

    // Hide arrows if total slides are 4 or less
    arrows: totalSlides > 4,

    // Optional: hide dots also
    pagination: totalSlides > 4,

    rewind: false,

    breakpoints: {
      1440: {
        arrows: false,
      },
      1199: {
        perPage: 3,
        arrows: totalSlides > 3,
        pagination: totalSlides > 3,
      },
      992: {
        perPage: 2,
        arrows: totalSlides > 2,
        pagination: totalSlides > 2,
      },
      480: {
        perPage: 1,
        arrows: totalSlides > 1,
        pagination: totalSlides > 1,
      },
    },
  });

  function updateClasses() {
    const slides = splide.Components.Elements.slides;

    slides.forEach((slide) => {
      slide.classList.remove('is-prev', 'is-next');
    });

    const activeIndex = splide.index;

    if (slides[activeIndex - 1]) {
      slides[activeIndex - 1].classList.add('is-prev');
    }

    if (slides[activeIndex + 1]) {
      slides[activeIndex + 1].classList.add('is-next');
    }
  }

  splide.on('mounted move', function () {
    updateClasses();
  });

  splide.mount();
});